<template>
    <q-card-section class="modal-content">
        <span class="modal-title">Забыли пароль?</span>
        <div class="q-gutter-sm">
            <q-radio v-model="type" val="phone_number" label="По номеру телефона" />
            <q-radio v-model="type" val="email" label="По E-mail" />
        </div>
        <div class="signin-type mt-3">
            <div v-show="type === 'phone_number'" class="form-group form-group--phone">
                <q-input
                    square
                    outlined
                    v-model="phone_number"
                    @blur="blurPhoneNumber"
                    @focus="fillMask = true"
                    mask="+7 (###) ###-##-##"
                    label="Ваш телефон"
                    :fill-mask="fillMask"
                    @keydown="remember.errors.clear('phone_number')"
                    :error-message="remember.errors.get('phone_number')"
                    :error="remember.errors.has('phone_number')">

                    <template v-slot:after>
                        <q-btn label="Получить СМС" @click.prevent="remind" :disable="disable.phone_number" />
                    </template>
                </q-input>

                <div v-if="messageSent.phone_number">Сообщение успешно отправлено</div>
                <div v-if="timer.phone_number">Вы можете повторить попытку через {{ currentTime.phone_number }}</div>
            </div>
            <div v-show="type === 'email'" class="form-group form-group--email">
                <q-input
                    square
                    outlined
                    v-model="email"
                    label="Ваш email"
                    fill-mask
                    @keydown="remember.errors.clear('email')"
                    :error-message="remember.errors.get('email')"
                    :error="remember.errors.has('email')" >

                    <template v-slot:after>
                        <q-btn label="Выслать на Email" @click.prevent="remind" :disable="disable.email" />
                    </template>
                </q-input>

                <div v-if="messageSent.email">Сообщение успешно отправлено</div>
                <div v-if="timer.email">Вы можете повторить попытку через {{ currentTime.email }}</div>
            </div>
            <div v-if="messageSent.email || messageSent.phone_number">
                <q-input
                    square
                    outlined
                    v-model="codeForm.code"
                    label="Одноразовый код"
                    @keydown="codeForm.errors.clear('code')"
                    :error-message="codeForm.errors.get('code')"
                    :error="codeForm.errors.has('code')">
                    <template v-slot:after>
                        <q-btn color="secondary" label="Войти" @click.prevent="loginByCode" />
                    </template>
                </q-input>
<!--                <q-input
                        square
                        outlined
                        v-model="password"
                        label="Пароль"
                        :type="isPwd ? 'password' : 'text'"
                        :error-message="login.errors.get('password')"
                        :error="login.errors.has('password')">
                    <template v-slot:append>
                        <q-icon
                                :name="isPwd ? 'visibility_off' : 'visibility'"
                                class="cursor-pointer"
                                @click="isPwd = !isPwd"
                        />
                    </template>
                    <template v-slot:after>
                        <q-btn color="secondary" label="Войти" @click.prevent="loginAfterRemind" />
                    </template>
                </q-input>-->
            </div>
        </div>
    </q-card-section>
</template>

<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import phoneNumberMixin from './../../../mixins/phone_number';
    import {Form} from "../../../classes/Form";

    export default {
        name: 'Remember',
        mixins: [
            phoneNumberMixin,
        ],
        data () {
            return {
                isPwd: true,
                passwordType: 'password',
                fillMask: false,
                messageSent: {
                    phone_number: false,
                    email: false,
                },
                timer: {
                    phone_number: false,
                    email: false,
                },
                waitingTime: {
                    phone_number: 60,
                    email: 60,
                },
                currentTime: {
                    phone_number: 0,
                    email: 0,
                },
                disable: {
                    phone_number: false,
                    email: false,
                },
                codeForm: new Form({
                    code: '',
                })
            }
        },
        watch: {
            'currentTime.phone_number' (time) {
                if (time === 0) {
                    this.stopTimer();
                }
            },
            'currentTime.email' (time) {
                if (time === 0) {
                    this.stopTimer();
                }
            },
            type: function (newValue, oldValue) {
                if (newValue === 'phone_number') {
                    this.email = '';
                } else {
                    this.phone_number = '';
                }
            }
        },
        methods: {
            ...mapMutations('auth', [
                'hideModal',
            ]),
            ...mapActions('auth', {
                loginTo: 'login',
                processAuthResponse: 'processAuthResponse',
            }),
            startTimer () {
                this.currentTime[this.type] = this.waitingTime[this.type];

                this.timer[this.type] = setInterval(() => {
                    this.currentTime[this.type]--
                }, 1000);
            },
            stopTimer () {
                clearTimeout(this.timer[this.type]);
                this.timer[this.type] = false;
                this.disable[this.type] = false;
            },
            blurPhoneNumber () {
                this.fillMask = false;

                if (!this.validatePhoneNumber(this.phone_number)) {
                    this.phone_number = '';
                }
            },
            loginAfterRemind () {
                let _this = this;
                _this.loginTo();
            },
            remind () {
                let _this = this;

                _this.disable[_this.type] = true;

                _this.remember.post('/remind-password/' + (_this.type === 'phone_number' ? 'phone' : 'email'))
                    .then(response => {
                        if (response.status === 'success') {
                            _this.startTimer();

                            _this.messageSent[_this.type] = true;
                        } else {
                            _this.timer[_this.type] = 0;
                        }
                        _this.disable[_this.type] = false;
                }).catch(errors => {
                    _this.timer[_this.type] = 0;
                    _this.disable[_this.type] = false;
                });
            },
            loginByCode () {
                let _this = this;

                _this.disable[_this.type] = true;

                _this.codeForm.put('/login/code/' + (_this.type === 'phone_number' ? 'phone' : 'email'))
                    .then(response => {
                        if (response.status === 'success') {
                            this.processAuthResponse(response);
                        } else {
                            _this.disable[_this.type] = false;
                        }
                    }).catch(errors => {
                        _this.disable[_this.type] = false;
                    });
            }
        },
        computed: {
            ...mapState('auth', ['remember', 'login']),

            type: {
                get () {
                    return this.$store.state.auth.remember.type;
                },
                set (value) {
                    this.$store.commit('auth/setFormValue', {
                        key: 'type',
                        value: value,
                        formName: 'remember'
                    });
                }
            },
            phone_number: {
                get () {
                    return this.$store.state.auth.remember.phone_number;
                },
                set (value) {
                    this.$store.commit('auth/setFormValue', {
                        key: 'phone_number',
                        value: value,
                        formName: 'remember'
                    });
                }
            },
            email: {
                get () {
                    return this.$store.state.auth.remember.email;
                },
                set (value) {
                    this.$store.commit('auth/setFormValue', {
                        key: 'email',
                        value: value,
                        formName: 'remember'
                    });
                }
            },
            password: {
                get () {
                    return this.$store.state.auth.login.password;
                },
                set (value) {

                    this.$store.commit('auth/setFormValue', {
                        key: 'password',
                        value: value,
                        formName: 'login'
                    });

                    this.$store.commit('auth/setFormValue', {
                        key: 'type',
                        value: this.type,
                        formName: 'login'
                    });

                    this.$store.commit('auth/setFormValue', {
                        key: this.type,
                        value: this[this.type],
                        formName: 'login'
                    });
                }
            },
        }
    }
</script>
